/* ADG Header — desktop mega/dropdown + Heather's three-level mobile drawer. No deps. */
(function () {
  'use strict';
  var header = document.querySelector('[data-adg-header]');
  if (!header) return;

  var scrim = header.querySelector('[data-adg-scrim]');
  var items = Array.prototype.slice.call(header.querySelectorAll('[data-adg-item]'))
    .filter(function (it) { return it.querySelector('[data-adg-trigger]') && it.querySelector('[data-adg-panel]'); });
  var openItem = null;
  var hoverTimer = null;
  var suppressFocusOpen = false;   // Escape hands focus back to the trigger without re-opening
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function open(item) {
    if (openItem && openItem !== item) close(openItem, true);
    item.classList.add('is-open');
    var t = item.querySelector('[data-adg-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
    openItem = item;
    if (scrim) scrim.hidden = false;
  }
  function close(item, keepScrim) {
    if (!item) return;
    item.classList.remove('is-open');
    var t = item.querySelector('[data-adg-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (item === openItem) openItem = null;
    if (!keepScrim && scrim) scrim.hidden = true;
  }
  function closeAll() { if (openItem) close(openItem); }

  items.forEach(function (item) {
    var trig = item.querySelector('[data-adg-trigger]');

    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      open(item);
    });
    item.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { close(item); }, 140);
    });
    trig.addEventListener('click', function (e) {
      var href = trig.getAttribute('href');
      // On desktop the panel already opens on hover, so a click on a real
      // parent link should navigate (e.g. Shop Art → all art). Placeholder
      // ("#") triggers still just toggle the dropdown.
      if (isDesktop() && href && href !== '#') return;
      e.preventDefault();
      if (openItem === item) close(item); else open(item);
    });
    // Keyboard (WCAG 2.1.1): the trigger is a real link, so Enter navigates
    // and hover never happens. Tabbing onto it opens the panel, Down arrow
    // jumps into it, and the panel closes once focus has left the item.
    /* Focus opens the panel so keyboard users can SEE it, but its links stay
       out of the Tab order until Down Arrow enters it: otherwise one Tab
       through Shop Art cost ~35 stops (RC check B, 2026-10-07). The trigger
       tells screen readers so (aria-describedby="adg-hdr-menu-hint"). */
    // Looked up each time: the panel's columns can be filled after load.
    function panelLinksNow() {
      return Array.prototype.slice.call(item.querySelectorAll('[data-adg-panel] a[href], [data-adg-panel] button'));
    }
    function setPanelTabbable(on) {
      panelLinksNow().forEach(function (el) {
        if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
      });
    }
    setPanelTabbable(false);
    trig.addEventListener('focus', function () { if (isDesktop() && !suppressFocusOpen) open(item); });
    trig.addEventListener('keydown', function (e) {
      if (!isDesktop()) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(item);
        setPanelTabbable(true);
        var links = panelLinksNow();
        if (links[0]) links[0].focus();
      }
    });
    item.addEventListener('mouseenter', function () { setPanelTabbable(true); });
    item.addEventListener('focusout', function (e) {
      if (!isDesktop()) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      close(item);
      setPanelTabbable(false);
    });
  });

  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) closeAll();
  });
  window.addEventListener('resize', function () { if (!isDesktop()) closeAll(); });

  /* ------------------------------------------------------------------
   * Mobile drawer — a stack of panels, one visible at a time.
   *
   * Heather drew three levels (archive/design/figma/pages/mobile-wireframes:
   * parent-nav → shop-art-menu → art-category-menu). Every panel is already
   * in the DOM, so drilling is a class change: no fetch, no re-render, no
   * flash. `stack` is the breadcrumb from root to whatever is on screen;
   * panels behind it get .is-past so they slide out to the left rather than
   * the right, which is what makes back feel like back.
   * ------------------------------------------------------------------ */
  var burger = header.querySelector('[data-adg-burger]');
  var drawer = header.querySelector('[data-adg-drawer]');
  var panels = Array.prototype.slice.call(header.querySelectorAll('[data-adg-dpanel]'));
  var stack = ['root'];

  function panelById(id) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-adg-dpanel') === id) return panels[i];
    }
    return null;
  }

  function paint(moveFocus) {
    var current = stack[stack.length - 1];
    panels.forEach(function (p) {
      var id = p.getAttribute('data-adg-dpanel');
      var inStack = stack.indexOf(id) !== -1;
      p.classList.toggle('is-active', id === current);
      p.classList.toggle('is-past', inStack && id !== current);
    });
    var active = panelById(current);
    if (!active) return;
    // A panel drilled into, then left and re-entered, should start at the top.
    active.scrollTop = 0;
    if (moveFocus) {
      var target = active.querySelector('[data-adg-dback-btn], [data-adg-drawer-close]');
      if (target && target.focus) target.focus({ preventScroll: true });
    }
  }

  function drill(id) {
    if (!panelById(id)) return;
    stack.push(id);
    paint(true);
  }
  function back() {
    if (stack.length < 2) return;
    stack.pop();
    paint(true);
  }

  var closeTimer = null;

  function openDrawer() {
    if (!drawer) return;
    // Opening always starts at the top level. Doing the reset HERE rather than
    // on the close timer matters: reopen inside the 240ms slide-out and the
    // timer would either leave the old stack in place or, worse, fire later
    // and yank an already-open menu back to root.
    clearTimeout(closeTimer);
    stack = ['root'];
    paint(false);
    drawer.hidden = false;
    requestAnimationFrame(function () {
      header.classList.add('is-drawer-open');
      // Keyboard and screen-reader users land inside the drawer, on its
      // close button, rather than staying on the burger behind it.
      paint(true);
    });
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setBackgroundInert(true);
  }
  /* While the drawer is open everything else on the page is inert, so a
     screen reader's virtual cursor and Tab cannot reach the page behind it
     (it is a modal dialog). Walk up from the drawer and mark every sibling at
     each level; undo exactly those on close. */
  var inerted = [];
  function setBackgroundInert(on) {
    if (!on) { inerted.forEach(function (el) { el.inert = false; }); inerted = []; return; }
    var node = drawer;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sib) {
        if (sib !== node && !sib.inert && sib.tagName !== 'SCRIPT' && sib.tagName !== 'STYLE' && !sib.hasAttribute('data-adg-scrim')) { sib.inert = true; inerted.push(sib); }
      });
      node = parent;
    }
  }
  function closeDrawer() {
    var wasInside = drawer && drawer.contains(document.activeElement);
    setBackgroundInert(false);
    header.classList.remove('is-drawer-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (wasInside && burger) burger.focus({ preventScroll: true });
    // The panels are deliberately left where they are while it slides away —
    // nothing should be seen snapping back behind the closing drawer.
    closeTimer = setTimeout(function () { if (drawer) drawer.hidden = true; }, 240);
  }

  if (burger) burger.addEventListener('click', openDrawer);

  if (drawer) {
    // Tab stays inside the open drawer (WCAG 2.1.2): wrap from the last
    // control of the active panel back to its first, and vice versa.
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !header.classList.contains('is-drawer-open')) return;
      var active = panelById(stack[stack.length - 1]);
      if (!active) return;
      var focusables = Array.prototype.filter.call(
        active.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
      );
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    });
    drawer.addEventListener('click', function (e) {
      var drillBtn = e.target.closest('[data-adg-drill]');
      if (drillBtn) { drill(drillBtn.getAttribute('data-adg-drill')); return; }
      if (e.target.closest('[data-adg-dback-btn]')) { back(); return; }
      if (e.target.closest('[data-adg-drawer-close]')) { closeDrawer(); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (header.classList.contains('is-drawer-open')) {
      // Escape backs out one level at a time, then closes — same as the
      // hardware back button people expect on a phone.
      if (stack.length > 1) back(); else closeDrawer();
      return;
    }
    if (openItem) {
      var t = openItem.querySelector('[data-adg-trigger]');
      var inside = openItem.contains(document.activeElement);
      closeAll();
      if (inside && t) {
        suppressFocusOpen = true;
        t.focus();
        suppressFocusOpen = false;
      }
    }
  });

  window.addEventListener('resize', function () {
    if (isDesktop() && header.classList.contains('is-drawer-open')) closeDrawer();
  });

  paint(false);
})();

/* Skip to content (WCAG 2.4.1). The stock link (layout/theme.liquid renders
   snippets/skip-to-content-link.liquid, href "#MainContent") only moves the
   browser's "next Tab starts here" point, because <main> is not focusable; a
   screen reader that follows real focus stays on the link. So, for the moment
   it is used: make the target focusable, focus it, and drop the tabindex again
   on blur so a later click inside main never focuses the whole region. The
   link's own fragment jump still runs (URL and scroll as before); on product
   pages adg-product.js ignores that same-document history entry. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a.skip-to-content-link') : null;
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
      target.setAttribute('data-adg-skip-target', '');
      target.addEventListener('blur', function onBlur() {
        target.removeEventListener('blur', onBlur);
        target.removeAttribute('tabindex');
        target.removeAttribute('data-adg-skip-target');
      });
    }
    target.focus();
  });
})();

/* Cart count badge. The header renders `.adg-hdr__cart-count` from
   cart.item_count once, server-side. On the cart page Horizon removes lines
   and changes quantities in place and announces each change with its
   `cart:update` event (ThemeEvents.cartUpdate, assets/events.js); so does
   assets/adg-cart-byo.js. Without this the badge kept the old count until a
   reload. When the event carries the cart (`resource.item_count`, as a
   /cart/change.js response does) that count is used; otherwise (an add,
   whose response is the added line, not the cart) /cart.js is asked. A page
   restored from the back-forward cache is re-checked the same way. */
(function () {
  'use strict';
  var link = document.querySelector('[data-adg-header] .adg-hdr__cart');
  if (!link) return;

  function setCount(n) {
    if (typeof n !== 'number' || !isFinite(n) || n < 0) return;
    // The link's name carries the count (WCAG 4.1.2, RC check B M8); the badge is visual.
    link.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
    var badge = link.querySelector('.adg-hdr__cart-count');
    if (n === 0) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'adg-hdr__cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    badge.textContent = String(n);
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCount(cart.item_count); })
      .catch(function () { /* keep the count we have */ });
  }

  document.addEventListener('cart:update', function (e) {
    var resource = e.detail && e.detail.resource;
    if (resource && typeof resource.item_count === 'number') setCount(resource.item_count);
    else refresh();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();
